var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['badge', _vm.isAlt ? 'badge--alt' : '', _vm.isNew ? 'badge--new' : '']},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }